/** @format */

import { getSingleton, registerSingleton } from 'fe-lib-singleton'
import rawStyled, * as rawNs from 'styled-components'

var styled = getSingleton('styled')
var ns = getSingleton('styled_ns')

if (styled == null) styled = registerSingleton('styled', rawStyled)
if (ns == null) ns = registerSingleton('styled_ns', rawNs)

export const ThemeProvider = ns.ThemeProvider
export const css = ns.css
export const keyframes = ns.keyframes
export const injectGlobal = ns.injectGlobal
export const withTheme = ns.withTheme

export default styled
